import { RouteConfig } from 'vue-router'

export const LOGIN_NAME = 'LoginView'
export const LOGIN_PATH = '/login'

export const CHOOSE_CUSTOMER_NAME = 'ChooseCustomerView'
export const CHOOSE_CUSTOMER_PATH = '/customer'

export const authRoutesConfig: RouteConfig[] = [
  {
    path: LOGIN_PATH,
    name: LOGIN_NAME,
    component: () => import('@/features/auth/views/Login.view.vue')
  },
  {
    path: CHOOSE_CUSTOMER_PATH,
    name: CHOOSE_CUSTOMER_NAME,
    component: () => import('@/features/auth/views/ChooseCustomer.view.vue')
  }
]
